import { render, staticRenderFns } from "./OrderSupplierItem.vue?vue&type=template&id=7015ba8a&scoped=true&lang=pug&"
import script from "./OrderSupplierItem.vue?vue&type=script&lang=ts&"
export * from "./OrderSupplierItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSupplierItem.vue?vue&type=style&index=0&id=7015ba8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015ba8a",
  null
  
)

export default component.exports